import { ElementsArray } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

const DUPLICATE_OFFSET = 50;

export function duplicateElements(store: StoreType, elements: ElementsArray) {
    const clonedElements = elements.map(element => element.clone());

    clonedElements.forEach(element => {
        element.set({
            x: element.x + DUPLICATE_OFFSET,
            y: element.y + DUPLICATE_OFFSET,
        });
    });

    store.selectElements(clonedElements.map(element => element.id));
}
